var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { space, fontSize } from 'styled-system';
import { ChevronDown } from 'pcln-icons';
import { ChipContent } from '../ChipContent';
import { ChipContentWrapper } from '../ChipContentWrapper';
import { Button } from '../../Button';
import { getPaletteColor } from '../../utils';
var ChipButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  &:hover {\n    background-color: transparent;\n  }\n  &:focus {\n    box-shadow: none;\n    outline-offset: 2px;\n    outline: 3px solid ", ";\n  }\n  &:focus > ", " {\n    border-color: ", ";\n  }\n"], ["\n  background-color: transparent;\n  border: none;\n  padding: 0;\n  &:hover {\n    background-color: transparent;\n  }\n  &:focus {\n    box-shadow: none;\n    outline-offset: 2px;\n    outline: 3px solid ", ";\n  }\n  &:focus > ", " {\n    border-color: ", ";\n  }\n"])), getPaletteColor('base'), ChipContentWrapper, getPaletteColor('base'));
var getTitle = function (_a) {
    var disabled = _a.disabled, expanded = _a.expanded;
    return (disabled ? 'Disabled' : expanded ? 'Collapse' : 'Expand');
};
var propTypes = __assign(__assign(__assign({}, space.propTypes), fontSize.propTypes), { id: PropTypes.string.isRequired, onClick: PropTypes.func.isRequired, disabled: PropTypes.bool, expanded: PropTypes.bool, facet: PropTypes.string, label: PropTypes.string, bridgeLabel: PropTypes.string, BridgeIcon: PropTypes.node, Icon: PropTypes.node, showActionIcon: PropTypes.bool, Image: PropTypes.object });
var ButtonChip = React.forwardRef(function (_a, ref) {
    var id = _a.id, m = _a.m, disabled = _a.disabled, expanded = _a.expanded, children = _a.children, onClick = _a.onClick, label = _a.label, showActionIcon = _a.showActionIcon, props = __rest(_a, ["id", "m", "disabled", "expanded", "children", "onClick", "label", "showActionIcon"]);
    return (React.createElement(ChipButton, { id: id, "data-testid": id, ref: ref, disabled: disabled, onClick: onClick, "aria-expanded": expanded, m: m },
        React.createElement(ChipContent, __assign({ label: label, disabled: disabled, selected: expanded, action: showActionIcon && {
                Icon: ChevronDown,
                title: getTitle({ disabled: disabled, expanded: expanded }),
            } }, props), children)));
});
ButtonChip.displayName = 'ButtonChip';
ButtonChip.propTypes = propTypes;
ButtonChip.defaultProps = {
    color: 'primary',
};
export default ButtonChip;
var templateObject_1;
//# sourceMappingURL=ButtonChip.js.map